import { PageSEO } from 'components/SEO'
import { OtherPage } from 'contentlayer/generated'
import siteMetadata from 'data/siteMetadata'
import React, { FunctionComponent } from 'react'

interface IOtherPageLayoutProps {
  content: OtherPage
}

const OtherPageLayout: FunctionComponent<IOtherPageLayoutProps> = ({
  content,
  children,
}): JSX.Element => {
  const { title, description } = content

  return (
    <>
      <PageSEO title={`${title} - ${siteMetadata.title}`} description={description} key={title} />
      <div className="divide-y divide-gray-200 dark:divide-gray-700">
        <div className="pt-6 pb-8 space-y-2 md:space-y-5" data-aos="zoom-in-down">
          <h1 className="text-3xl font-extrabold leading-9 tracking-tight text-gray-900 dark:text-gray-100 sm:text-4xl sm:leading-10 md:text-6xl md:leading-14">
            {title}
          </h1>
          <p className="text-lg leading-7 text-gray-500 dark:text-gray-300">{description}</p>
        </div>
        <div className="container py-12">
          <div className="flex flex-wrap -my-4">
            <div className="pt-10 pb-8 prose dark:prose-dark max-w-none w-full">{children}</div>
          </div>
        </div>
      </div>
    </>
  )
}

export default OtherPageLayout
